import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs';
import { of as observableOf, throwError as observableThrowError } from 'rxjs';
import { catchError, map, concatMap } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';
import { ContextService, MenuItem, LoginResponse } from '../core/context.service';
import { BranchService } from './branch.service';

@Injectable()
export class UserService {
  private baseApiUrl: string;

  constructor(configurationService: ConfigurationService, private contextService: ContextService,
    private httpClient: HttpClient, private branchService: BranchService) {
    this.baseApiUrl = configurationService.BaseApiUrl;
  }

  /*getFilteredUsers(filter: string, pageIndex: number, pageSize: number, sortColumn: string, sortAscending: boolean): Observable<any> {
    let params = new HttpParams();
    params = params.append('filter', filter);
    params = params.append('pageIndex', pageIndex.toString());
    params = params.append('pageSize', pageSize.toString());
    params = params.append('sortColumn', sortColumn);
    params = params.append('sortAscending', sortAscending.toString());

    return this.httpClient.get(`${this.baseApiUrl}user/filter`, { params: params }).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }*/
  getFiltered(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean, isMaintenance: boolean = true): Observable<any> {

    const params = {
      filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
    };

    return this.httpClient.post(this.baseApiUrl + 'user/filter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getAllUsers(): Observable<any> {
    return this.httpClient.get(`${this.baseApiUrl}user`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }

  getAllAuthorisers(): Observable<any> {
    return this.httpClient.get(`${this.baseApiUrl}user/authoriser`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }
  getAuthorise(id: number): Observable<any> {
    return this.httpClient.post(`${this.baseApiUrl}user/authorise`,id).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }

  getUser(id: number): Observable<any> {
    return this.httpClient.get(`${this.baseApiUrl}user/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }

  createUser(user: any): Observable<any> {
    return this.httpClient.post(`${this.baseApiUrl}user`, user).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }

  updateUser(user: any): Observable<any> {
    return this.httpClient.put(`${this.baseApiUrl}user`, user).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }

  login(userName: string, password: string, logoutOtherSession: boolean): Observable<any> {
    const body = { userName, password, logoutOtherSession };
    let loginData: any = {};

    return this.httpClient.post<LoginResponse>(`${this.baseApiUrl}user/login`, body).pipe(
      concatMap(data => {
        this.contextService.setLoginData(data);
        loginData = data;
       // return this.branchService.getBranchSettings(data.user.homeBranch.id);
        return this.branchService.getBranchSettings(data.user.currentBranch.id);

      }),
      concatMap(result => {
        this.contextService.setCurrentBranchSettings(result);
        this.contextService.setCurrentBranch(loginData.user.homeBranch.id);
          this.contextService.setBranchData(result)
        return observableOf({ loginData, branchSettings: result });
      })
    );
  }

  logout(): Subscription {
    return this.httpClient.post(`${this.baseApiUrl}user/logout`, {})
      .subscribe(
        data => {
          console.log('User service clearing login data');
          this.contextService.clearLoginData();
        },
        (err: HttpErrorResponse) => {
          console.log('Error while logging out', err);
        });
  }

  getMenu(): Observable<any> {
    if (this.contextService.menu.length > 0) {
      return observableOf(this.contextService.menu);
    }

    return this.httpClient.get(this.baseApiUrl + 'user/menu').pipe(
      map((res: any) => {
        this.contextService.setMenuItems(res.items as Array<MenuItem>);
        return this.contextService.menu;
      }),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  forgotPassword(user: any): Observable<any> {
    return this.httpClient.put(`${this.baseApiUrl}user/ForgotPassword`, user).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }
  changePassword(user: any): Observable<any> {
    return this.httpClient.put(`${this.baseApiUrl}user/ChangePassword`, user).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }

  ValidateUser(user: any): Observable<any> {
    return this.httpClient.post(`${this.baseApiUrl}user/ValidateUser`, user).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }

  generateLicence(siteCode: string): Observable<any> { 
    return this.httpClient.post(this.baseApiUrl +`user/generatelicence/?siteCode=${siteCode}`, siteCode).pipe(  
      map((res: Response) => res),   catchError((err: any) => observableThrowError(err.message || 'Server error')) 
       ); 
    }

  getEnableDisable(id: number): Observable<any> {
    return this.httpClient.get(`${this.baseApiUrl}user/enabledisable/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error'))
    );
  }
  
  changeuserbranch(userId: number, branchId: number
  ): Observable<any> {
    const body = { userId, branchId};
    let loginData: any = {};

    return this.httpClient
      .post<LoginResponse>(`${this.baseApiUrl}user/logintootherchange`, body)
      .pipe(
        concatMap((data) => {
          this.contextService.setLoginData(data);
          
          loginData = data;
          return this.branchService.getBranchSettings(data.user.currentBranch.id);
          
        }),
        concatMap((result) => {
          console.log('result',result);
          this.contextService.setCurrentBranchSettings(result);
          this.contextService.setCurrentBranch(loginData.user.currentBranch.id);
          this.contextService.setBranchData(result)
          return observableOf({ loginData, branchSettings: result });
        })
      );
  }

    getLoanOfficer(branchId: number): Observable<any> {
    return this.httpClient.get(`${this.baseApiUrl}user/getLoanOfficer/${branchId}`).pipe(
     map((res: Response) => res),
      catchError((err: any) =>
        observableThrowError(err.message || "Server error")
      )
    );
  }


}


